import styled from 'styled-components'

/** Linha de cards dos novos indicadores — segue o padrão flex das demais seções. */
export const CardsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;
`

/** Card branco arredondado, mesmo visual dos cards existentes da dashboard. */
export const IndicatorCardContainer = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
  flex: 1 1 320px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const CardTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #101828;
  margin: 0;
`

export const ToggleLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  color: #475467;
  cursor: pointer;
  user-select: none;

  input {
    cursor: pointer;
  }
`

/* -------- Donut -------- */
export const DonutContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
`

export const DonutChartBox = styled.div`
  width: 168px;
  height: 168px;
  flex-shrink: 0;
`

/* Donut estilo "foto": maior, com espaço para rótulos ao redor */
export const DonutChartBoxLg = styled.div`
  width: 100%;
  max-width: 440px;
  height: 320px;
  margin: 0 auto;
`

export const LegendList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-width: 150px;
`

export const LegendItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
`

export const LegendDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex-shrink: 0;
`

export const LegendLabel = styled.span`
  flex: 1;
  color: #344054;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const LegendValue = styled.span`
  font-weight: 600;
  color: #101828;
`

/* -------- Bar (faixa etária) -------- */
export const BarChartBox = styled.div<{ $height: number }>`
  width: 100%;
  height: ${(props) => props.$height}px;
`

export const EmptyState = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #98a2b3;
  padding: 24px 0;
  text-align: center;
`

/* -------- Curva de Vendas -------- */
export const CurveBody = styled.div`
  display: grid;
  grid-template-columns: minmax(240px, 0.85fr) 1.25fr;
  gap: 32px;
  align-items: center;

  @media (max-width: 820px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`

export const CurveChartCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
`

export const CurveDonutBox = styled.div`
  width: 210px;
  height: 210px;
`

export const CurveLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  justify-content: center;
`

export const CurvePeriods = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const PeriodRow = styled.div<{ $color: string; $tint: string }>`
  display: flex;
  gap: 16px;
  padding: 16px 18px;
  border-radius: 13px;
  position: relative;
  overflow: hidden;
  background: ${(p) => p.$tint};

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: ${(p) => p.$color};
  }
`

export const PeriodMain = styled.div`
  flex: 1;
  min-width: 0;
`

export const PeriodTop = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
`

export const PeriodName = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 15.5px;
  font-weight: 600;
  color: #101828;
`

export const PeriodRange = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #98a2b3;
`

export const PeriodMetrics = styled.div`
  display: flex;
  gap: 26px;
  margin-top: 12px;
  flex-wrap: wrap;
`

export const PMetric = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const PMetricLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #98a2b3;
`

export const PMetricVal = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #101828;
  font-variant-numeric: tabular-nums;
`

export const PeriodRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 3px;
  padding-left: 8px;
`

export const PeriodPct = styled.span<{ $color: string }>`
  font-family: 'Inter', sans-serif;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
  color: ${(p) => p.$color};
`

export const PeriodAcc = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 11.5px;
  color: #98a2b3;
`

/* -------- Modal de configuração da Curva de Vendas -------- */
export const GearButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: transparent;
  color: #475467;
  border: 1px solid #e6e9ee;
  border-radius: 9px;
  padding: 8px 12px;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #f4f6f9;
    color: #101828;
  }
  svg {
    width: 15px;
    height: 15px;
  }
`

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(16, 24, 40, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1000;
`

export const ModalPanel = styled.div`
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 560px;
  padding: 26px 28px;
  box-shadow: 0 20px 40px rgba(16, 24, 40, 0.2);
`

export const ModalHead = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
`

export const ModalTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 17px;
  font-weight: 600;
  color: #101828;
  margin: 0;
  flex: 1;
`

export const ModalClose = styled.button`
  background: transparent;
  border: none;
  color: #98a2b3;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
  &:hover {
    color: #101828;
  }
`

export const ModalSub = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  color: #475467;
  margin: 0 0 20px;
`

export const CfgBadge = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #2e5aac;
  background: #eef2fb;
  padding: 3px 9px;
  border-radius: 999px;
`

export const CfgRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const CfgRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`

export const CfgIdx = styled.span<{ $color: string }>`
  width: 26px;
  height: 26px;
  border-radius: 7px;
  display: grid;
  place-items: center;
  font-family: 'Inter', sans-serif;
  font-size: 12.5px;
  font-weight: 700;
  color: #fff;
  background: ${(p) => p.$color};
  flex-shrink: 0;
`

export const CfgName = styled.span`
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #101828;
`

export const CfgInput = styled.input`
  width: 68px;
  padding: 7px 10px;
  border: 1px solid #e6e9ee;
  border-radius: 8px;
  background: #f4f6f9;
  color: #101828;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  text-align: right;
  font-variant-numeric: tabular-nums;

  &:focus {
    outline: 2px solid #2e5aac33;
    border-color: #2e5aac;
  }
`

export const CfgUnit = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  color: #98a2b3;
  width: 96px;
`

export const CfgAuto = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  color: #475467;
  font-style: italic;
  width: 96px;
  text-align: right;
`

export const CfgNote = styled.div<{ $error?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 18px;
  font-family: 'Inter', sans-serif;
  font-size: 12.5px;
  color: ${(p) => (p.$error ? '#d92d20' : '#98a2b3')};
`

export const ModalFoot = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
`

export const ModalBtn = styled.button<{ $variant?: 'primary' | 'ghost' }>`
  border-radius: 9px;
  padding: 9px 18px;
  font-family: 'Inter', sans-serif;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  border: ${(p) => (p.$variant === 'ghost' ? '1px solid #e6e9ee' : 'none')};
  background: ${(p) => (p.$variant === 'ghost' ? 'transparent' : '#2e5aac')};
  color: ${(p) => (p.$variant === 'ghost' ? '#475467' : '#fff')};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

/* -------- Formas de pagamento (barras horizontais) -------- */
export const BarsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 4px;
`

export const BarRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const BarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: 'Inter', sans-serif;
`

export const BarLabel = styled.span`
  font-size: 14px;
  color: #475467;
`

export const BarValue = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #101828;
`

export const BarTrack = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: #eef2f6;
  overflow: hidden;
`

export const BarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  transition: width 0.3s ease;
`

/* -------- Recorrência (medidores em anel) -------- */
export const GaugesWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 4px;
`

export const GaugeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`

export const GaugeRing = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const GaugeRingInner = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #101828;
`

export const GaugeInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const GaugeTitle = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  color: #344054;
`

export const GaugeCount = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #98a2b3;
`

/* -------- Card combinado: Mapa de Vendas + Estados -------- */
export const GeoCardContainer = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 28px 32px;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
  display: flex;
  align-items: stretch;
  gap: 24px;
  width: 100%;

  @media (max-width: 1024px) {
    flex-wrap: wrap;
  }
`

export const GeoCol = styled.div`
  flex: 1 1 0;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const GeoColTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 22px;
  font-weight: 500;
  color: #101828;
  margin: 0;
`

export const GeoDivider = styled.div`
  width: 1px;
  background: #eef2f6;
  align-self: stretch;

  @media (max-width: 1024px) {
    display: none;
  }
`

export const GeoMapRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const GeoStateList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  flex-shrink: 0;
`

export const GeoStateItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const GeoStateName = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  color: #98a2b3;
`

export const GeoStateCount = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #101828;
`

export const GeoMapBox = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  & svg[viewBox='0 0 320 336'] {
    width: 100%;
    max-width: 300px;
    height: auto;
  }
`
